import { createRouter, createWebHistory } from 'vue-router'
import { estaAutenticado } from '@/services/servicioAutenticacion'

// Layout principal
import AdminLayout from '@/components/AdminLayout.vue'

// Panel principal
import AdminDashboard from '@/views/dashboard/AdminDashboard.vue'

// Gestión de empresas
import EmpresasList from '@/views/empresas/EmpresasList.vue'
import EmpresasCrear from '@/views/empresas/EmpresasCrear.vue'
import EmpresasSubdominios from '@/views/empresas/EmpresasSubdominios.vue'

// Gestión de proveedores
import ProveedoresList from '@/views/proveedores/ProveedoresList.vue'
import ProveedorCrear from '@/views/proveedores/ProveedorCrear.vue'

// Usuarios administradores
import UsuariosList from '@/views/usuarios/UsuariosList.vue'
import UsuarioCrear from '@/views/usuarios/UsuarioCrear.vue'
import RolesPermisos from '@/views/usuarios/RolesPermisos.vue'
import AdminLoginView from '@/views/usuarios/Login.vue'

// Gestión de módulos del sistema
import ModulosGestion from '@/views/modulos/ModulosGestion.vue'
import ModulosPermisos from '@/views/modulos/ModulosPermisos.vue'
import ModulosActivacion from '@/views/modulos/ModulosActivacion.vue'

// Facturación del sistema (suscripciones, pagos)
import SuscripcionesList from '@/views/facturacion/SuscripcionesList.vue'
import PagosList from '@/views/facturacion/PagosList.vue'
import PlanesList from '@/views/facturacion/PlanesList.vue'

// Reportes centrales
import ReportesEmpresas from '@/views/reportes/ReportesEmpresas.vue'
import ReportesIngresos from '@/views/reportes/ReportesIngresos.vue'
import ReportesUso from '@/views/reportes/ReportesUso.vue'

// Configuraciones centrales
import AdminConfiguracionUsuarios from '@/views/configuraciones/AdminConfiguracionUsuarios.vue'
import AdminConfiguracionParametros from '@/views/configuraciones/AdminConfiguracionParametros.vue'
import ConfiguracionSri from '@/views/sri/ConfiguracionSri.vue'

const routes = [
  { path: '/iniciar-sesion', name: 'InicioSesionAdmin', component: AdminLoginView },
  // Ruta temporal sin guardia para pruebas
  { path: '/iniciar-sesion-prueba', name: 'InicioSesionPrueba', component: AdminLoginView, meta: { omitirGuardia: true } },
  // Ruta de depuración para forzar acceso al inicio de sesión
  { path: '/depuracion/iniciar-sesion', name: 'DepuracionInicioSesion', component: AdminLoginView },
  // Página de depuración para verificar estado de autenticación
  { path: '/depuracion/autenticacion', name: 'DepuracionAutenticacion', component: () => import('@/views/debug/AuthDebug.vue') },
  // Página de inicio de sesión simplificada para pruebas
  { path: '/iniciar-sesion-simple', name: 'InicioSesionSimple', component: () => import('@/views/SimpleLogin.vue') },
  // Página de prueba para verificar funcionamiento básico
  { path: '/prueba', name: 'PaginaPrueba', component: () => import('@/views/TestPage.vue') },
  // Redirección legacy
  { path: '/login', redirect: '/iniciar-sesion' },
  // Página de inicio y layout principal del panel
  {
    path: '/',
    component: AdminLayout,
    meta: { requiresAuth: true },
    children: [
      // Dashboard
      // Dashboard Central
      { path: '', name: 'Dashboard', component: AdminDashboard, meta: { requiresAuth: true } },

      // Gestión de Empresas
      { path: 'empresas', name: 'EmpresasList', component: EmpresasList, meta: { requiresAuth: true } },
      { path: 'empresas/nueva', name: 'EmpresasCrear', component: EmpresasCrear, meta: { requiresAuth: true } },
      { path: 'empresas/editar/:id', name: 'EmpresasEditar', component: EmpresasCrear, meta: { requiresAuth: true } },
      { path: 'empresas/subdominios', name: 'EmpresasSubdominios', component: EmpresasSubdominios, meta: { requiresAuth: true } },
      { path: 'empresas/usuarios', name: 'EmpresasUsuarios', component: () => import('@/views/empresas/EmpresasUsuarios.vue'), meta: { requiresAuth: true } },

      // Gestión de Proveedores
      { path: 'proveedores', name: 'ProveedoresList', component: ProveedoresList, meta: { requiresAuth: true } },
      { path: 'proveedores/nuevo', name: 'ProveedorCrear', component: ProveedorCrear, meta: { requiresAuth: true } },
      { path: 'proveedores/ver/:id', name: 'ProveedorVer', component: () => import('@/views/proveedores/ProveedorVer.vue'), meta: { requiresAuth: true } },
      { path: 'proveedores/editar/:id', name: 'ProveedorEditar', component: () => import('@/views/proveedores/ProveedorEditar.vue'), meta: { requiresAuth: true } },

      // Usuarios Administradores
      { path: 'usuarios', name: 'UsuariosList', component: UsuariosList, meta: { requiresAuth: true } },
      { path: 'usuarios/nuevo', name: 'UsuarioCrear', component: UsuarioCrear, meta: { requiresAuth: true } },
      { path: 'usuarios/roles', name: 'RolesPermisos', component: RolesPermisos, meta: { requiresAuth: true } },

      // Gestión de Módulos
      { path: 'modulos', name: 'ModulosGestion', component: ModulosGestion, meta: { requiresAuth: true } },
      { path: 'modulos/permisos', name: 'ModulosPermisos', component: ModulosPermisos, meta: { requiresAuth: true } },
      { path: 'modulos/activacion', name: 'ModulosActivacion', component: ModulosActivacion, meta: { requiresAuth: true } },

      // Facturación del Sistema (suscripciones, pagos)
      { path: 'facturacion/suscripciones', name: 'SuscripcionesList', component: SuscripcionesList, meta: { requiresAuth: true } },
      { path: 'facturacion/pagos', name: 'PagosList', component: PagosList, meta: { requiresAuth: true } },
      { path: 'facturacion/planes', name: 'PlanesList', component: PlanesList, meta: { requiresAuth: true } },

      // Reportes Centrales
      { path: 'reportes/empresas', name: 'ReportesEmpresas', component: ReportesEmpresas, meta: { requiresAuth: true } },
      { path: 'reportes/ingresos', name: 'ReportesIngresos', component: ReportesIngresos, meta: { requiresAuth: true } },
      { path: 'reportes/uso', name: 'ReportesUso', component: ReportesUso, meta: { requiresAuth: true } },

  // Configuraciones Centrales
  { path: 'configuraciones/usuarios', name: 'AdminConfiguracionUsuarios', component: AdminConfiguracionUsuarios, meta: { requiresAuth: true } },
  { path: 'configuraciones/parametros', name: 'AdminConfiguracionParametros', component: AdminConfiguracionParametros, meta: { requiresAuth: true } },
  { path: 'configuraciones/sri', name: 'ConfiguracionSri', component: ConfiguracionSri, meta: { requiresAuth: true } }
    ]
  },

  // Redirección raíz y rutas inválidas => home o inicio de sesión
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Guardia de autenticación con verificación de expiración del JWT
router.beforeEach((to, from, next) => {
  console.log('🔍 [GUARDIA RUTAS] ======= INICIO =======');
  console.log('🔍 [GUARDIA RUTAS] Desde:', from.path, '-> Hacia:', to.path);
  console.log('🔍 [GUARDIA RUTAS] Meta:', to.meta);
  console.log('🔍 [GUARDIA RUTAS] Query:', to.query);

  // Evitar ciclos: misma ruta y misma query
  if (to.path === from.path && JSON.stringify(to.query || {}) === JSON.stringify(from.query || {})) {
    console.warn('🔍 [GUARDIA RUTAS] Navegación duplicada bloqueada para evitar loop');
    return next(false);
  }

  // OMITIR GUARDIA: Permitir rutas que específicamente lo soliciten
  if (to.meta?.omitirGuardia) {
    console.log('🔍 [GUARDIA RUTAS] OMITIR GUARDIA: Ruta con omitirGuardia activado');
    return next();
  }

  const requiereAutenticacion = to.matched.some(r => r.meta?.requiresAuth);
  const autenticado = estaAutenticado();
  const modoDepuracion = to.query.depurar === 'true' || from.query.depurar === 'true';
  const rutasLogin = new Set(['/iniciar-sesion', '/login', '/iniciar-sesion-prueba', '/depuracion/iniciar-sesion', '/iniciar-sesion-simple']);

  console.log('🔍 [GUARDIA RUTAS] Análisis de autenticación:', {
    requiereAutenticacion,
    autenticado,
    modoDepuracion,
    ruta: to.path
  });

  // MODO DEPURACIÓN: Permitir acceso a todas las rutas sin autenticación
  if (modoDepuracion) {
    console.log('🔍 [GUARDIA RUTAS] MODO DEPURACIÓN: Permitir navegación');
    return next();
  }

  // Permitir acceso forzado al inicio de sesión con parámetro forzar
  if (to.path === '/iniciar-sesion' && to.query.forzar === 'true') {
    console.log('🔍 [GUARDIA RUTAS] INICIO FORZADO: Permitir acceso');
    return next();
  }

  if (requiereAutenticacion && !autenticado) {
    console.log('🔍 [GUARDIA RUTAS] Requiere autenticación y no autenticado -> redirigir');
    // limpiar tokens inválidos
    localStorage.removeItem('token_acceso_admin');
    localStorage.removeItem('token_refresco_admin');
    localStorage.removeItem('token_acceso_admin');
    localStorage.removeItem('token_refresco_admin');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    if (to.path === '/iniciar-sesion') {
      return next();
    }
    return next({ path: '/iniciar-sesion', query: { redireccion: to.fullPath }, replace: true });
  }

  if (rutasLogin.has(to.path) && autenticado) {
    console.log('🔍 [GUARDIA RUTAS] Ya autenticado -> redirigir al inicio');
    if (from.path === '/' || to.path === '/') {
      return next();
    }
    return next({ path: '/', replace: true });
  }

  console.log('🔍 [GUARDIA RUTAS] Navegación permitida');
  console.log('🔍 [GUARDIA RUTAS] ======= FIN =======');
  return next();
});

export default router
